import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import BubbleTail from "@app/neva/components/bubbleTail";
import "./typing.scss";

const messages = defineMessages({
  typingTailAriaLabel: {
    id: "typingTailAriaLabel",
    defaultMessage: "Typing indicator",
  },
});

const Typing: FC = () => {
  const intl = useIntl();
  return (
    <div role="alert" className="typing__container">
      <BubbleTail
        role="img"
        aria-label={intl.formatMessage(messages.typingTailAriaLabel)}
        isSendByUser={false}
        isShowAvatar={true}
      />
      <div className="typing__dots">
        <div className="typing__dot first" />
        <div className="typing__dot second" />
        <div className="typing__dot third" />
      </div>
    </div>
  );
};

export default Typing;
